import type { Region } from '@/api/regions';

/**
 * 検索用に正規化する。アクセント記号を落とし (Åland → aland)、小文字にする。
 * 利用者が英字キーボードで地域名を探せるようにするため。
 */
function normalize(value: string): string {
  return value.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase().trim();
}

/**
 * サジェストの候補を絞り込む。名前の部分一致に加えてコードの完全一致でもヒットさせ、
 * コードで探す人 (例: "us") のために完全一致を先頭に置く。それ以外はマスタ順を保つ。
 */
export function filterRegions(regions: readonly Region[], query: string): Region[] {
  const normalizedQuery = normalize(query);
  if (!normalizedQuery) {
    return [...regions];
  }

  const codeMatches = regions.filter((r) => r.code.toLowerCase() === normalizedQuery);
  const nameMatches = regions.filter(
    (r) => !codeMatches.includes(r) && normalize(r.name).includes(normalizedQuery),
  );
  return [...codeMatches, ...nameMatches];
}
